<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation class="dark bg-gray-900 print:hidden" [appearance]="'compact'"
  [mode]="isScreenSmall ? 'over' : 'side'" [name]="'mainNavigation'" [navigation]="navigation.compact"
  [opened]="!isScreenSmall">
  <!-- Navigation header hook -->
  <ng-container fuseVerticalNavigationContentHeader>
    <!-- Logo -->
    <div class="mb-4 mt-3 flex h-20 items-center justify-center">
      <img class="w-10" src="images/logo/logo.svg" alt="Logo image" />
    </div>
  </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
  <!-- Header -->
  <div
    class="bg-card relative z-49 flex h-16 w-full flex-0 items-center px-4 shadow dark:border-b dark:bg-transparent dark:shadow-none md:px-6 print:hidden">
    <!-- Navigation toggle button -->
    <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
      <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
    </button>
    <!-- Custom Header -->
    <app-custom-header></app-custom-header>

    <!-- Components -->
    <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
      @if (envConfigService.envConfig.enableMultiLanguage) {
        <languages></languages>
      }
      @if (envConfigService.envConfig.enableFullScreen) {
        <fuse-fullscreen class="hidden md:block"
        ></fuse-fullscreen>
      }
      @if (envConfigService.envConfig.enableGlobalSearch) {
        <search [appearance]="'bar'"></search>
      }
      @if (envConfigService.envConfig.enableShortcuts) {
        <shortcuts></shortcuts>
      }
      @if (envConfigService.envConfig.enableInboxMessages) {
        <messages></messages>
      }
      @if (envConfigService.envConfig.enableNotifications) {
        <notifications></notifications>
      }
      @if (envConfigService.envConfig.enableChats) {
        <button class="lg:hidden" mat-icon-button (click)="quickChat.toggle()"
          >
          <mat-icon [svgIcon]="'heroicons_outline:chat-bubble-left-right'"></mat-icon>
        </button>
      }
      <user></user>
    </div>
  </div>

  <!-- Content -->
  <div class="flex flex-auto flex-col">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
    Otherwise, layout changes won't be registered and the view won't be updated! -->
    @if (true) {
      <router-outlet></router-outlet>
    }
  </div>

  <!-- Footer -->
  <app-footer></app-footer>
</div>

<!-- Quick chat -->
@if (envConfigService.envConfig.enableChats) {
  <quick-chat #quickChat="quickChat"></quick-chat>
}